export default String.raw`
<g id="Nawigacja mobile">
    <g id="Frame 484">
        <g id="Frame 10">
            <rect width="360" height="48" class="topBannerBgColor"/>
            <g id="Frame 37">
                <g id="Frame 38">
                    <g id="Frame 36">
                        <text id="Reklama" class="topBannerFontColor" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="14" font-weight="500" letter-spacing="0px">
                            <tspan x="151.631" y="29.0909">TRANSLATION_Prv_Advertisement</tspan>
                        </text>
                    </g>
                </g>
            </g>
        </g>
        <g id="Frame 11">
            <rect width="360" height="40" transform="translate(0 48)" fill="#F8F9FA"/>
            <g id="Frame 43">
                <g id="Frame 453">
                    <g id="Text button ">
                        <text id="Text" class="primaryColorFont" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="14" letter-spacing="0px">
                            <tspan x="201.349" y="73.0909">PLN</tspan>
                        </text>
                        <g id="Arrows/chevron down" transform="translate(239.000000, 62.000000)">
                            <use class="hoverOverButton--stroke" xlink:href="#chevron-down" width="12" height="12"></use>
                        </g>
                    </g>
                    <g id="Frame 207">
                        <g id="Icons/24/Flags/pl">
                            <rect id="rectangle" x="0.5" y="-0.5" width="15" height="6" transform="matrix(1 0 0 -1 277 68)" fill="white" stroke="#DADADA"/>
                            <rect id="rectangle_2" x="277" y="68" width="16" height="6" fill="#CD4040"/>
                        </g>
                        <g id="Text button _2">
                            <text id="Text_2" class="primaryColorFont" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="14" letter-spacing="0px">
                                <tspan x="299.119" y="73.0909">PL</tspan>
                            </text>
                        <g id="Arrows/chevron down_2" transform="translate(326.000000, 62.000000)">
                            <use class="hoverOverButton--stroke" xlink:href="#chevron-down" width="12" height="12"></use>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </g>
    <g id="Frame 221">
        <rect width="360" height="72" transform="translate(0 88)" class="bgColor"/>
        <image id="logo" x="17" y="104" href="./img/logo_comarch_esklep.png" height="37" width="116" />
        <g id="1. Search - Basic">
            <g>
                <rect x="158.146" y="104" width="185.853" height="40" rx="5" class="bgColor" stroke="#D5D5D5"/>
                <text id="Szukaj po nazwie, indeksie, producencie..." fill="#767676" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="14" letter-spacing="0px">
                    <tspan x="174.146" y="129.091">TRANSLATION_Prv_HeaderSearchMobilePlaceholder</tspan>
                </text>
                <g id=".x/Search button">
                    <rect id="Rectangle 166" x="304" y="108" width="1" height="32" fill="#F3F3F3"/>
                    <g id="Interface/Search" transform="translate(314.000000, 114.000000)">
                        <use class="primaryColor--stroke" xlink:href="#search" width="19" height="19"></use>
                    </g>
                </g>
            </g>
        </g>
    </g>
    <line id="Divider" y1="159.5" x2="360" y2="159.5" class="lightBorderColor--stroke"/>
</g>
</g>
`;